<mat-toolbar>
  <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
    <div class="toolbar-block" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="0.5rem">
      <button mat-button [routerLink]="['../']">
        <mat-icon class="material-icons">keyboard_backspace</mat-icon>
      </button>
      <mat-divider [vertical]="true"></mat-divider>
      @if (ownerLabel$ | async; as ownerLabel) {
        <span>{{ ownerLabel }}</span>
      }
    </div>
    <button mat-raised-button *ngxPermissionsOnly="['WRITE_ABSENCES']" color="primary" (click)="editAbsence()">
      <mat-icon>add</mat-icon>
      {{ 'absences.actions.create' | translate }}
    </button>
  </mat-toolbar-row>
</mat-toolbar>

@if ((absences$ | async); as absences) {
  @for (yearAbsences of absences; track yearAbsences) {
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ yearAbsences[0] }}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <table mat-table [dataSource]="yearAbsences[1]" class="main-content">
        <ng-container matColumnDef="startDate">
          <th mat-header-cell *matHeaderCellDef>{{ 'absences.startDate' | translate }}</th>
          <td mat-cell *matCellDef="let absence">{{ absence.startDate | date : 'shortDate' }}</td>
        </ng-container>
        <ng-container matColumnDef="endDate">
          <th mat-header-cell *matHeaderCellDef>{{ 'absences.endDate' | translate }}</th>
          <td mat-cell *matCellDef="let absence">{{ absence.endDate | date : 'shortDate' }}</td>
        </ng-container>
        <ng-container matColumnDef="class">
          <th mat-header-cell *matHeaderCellDef>{{ 'absences.class' | translate }}</th>
          <td mat-cell *matCellDef="let absence">{{ (absence.class | absenceClass | async)?.name }}</td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let absence" class="actions-column">
            <mat-menu #driverActions>
              <button mat-menu-item (click)="editAbsence(absence)">{{ 'absences.actions.edit' | translate }}</button>
              <button mat-menu-item *ngxPermissionsOnly="['ROLE_USER']" (click)="deleteAbsence(absence['@id'])">{{ 'absences.actions.delete' | translate }}</button>
            </mat-menu>
            <button mat-button [matMenuTriggerFor]="driverActions">
              <mat-icon>more_vert</mat-icon>
            </button>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="tableColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let absence; columns: tableColumns"></tr>
      </table>
    </mat-expansion-panel>
  }
  @if (absences.length == 0 ) {
    <app-no-result-message></app-no-result-message>
  }
}


@if (actionPending$ | async) {
  <div class="spinner-container">
    <mat-spinner></mat-spinner>
  </div>
}
